import { useEffect, useState } from "react";
import Button from "react-bootstrap/Button";
import Modal from "react-bootstrap/Modal";
import { useTranslation } from "react-i18next";
import { FiPhoneCall } from "react-icons/fi";
import {
  IoLocationOutline,
  IoMailOutline,
  IoSearchSharp,
} from "react-icons/io5";
import { NavLink, useParams } from "react-router-dom";
import { useDebounce } from "use-debounce";
import { server } from "../../../../App";
import BusingSubscriptions from "../../../../component/Model/reservation/BusingSubscription";
import AdminPagination from "../../../../component/pagination/AdminPagination";
import { useGetAllVendorsQuery } from "../../../../store/api/school/VendorSlice";

const initialActions = { search: "" };

const initialPagination = {
  limit: 12,
  page: 1,
  total: "",
  totalPages: "",
};

const Vendors = () => {
  const { t } = useTranslation();
  const [show, setShow] = useState(false);
  const [selectedVendor, setSelectedVendor] = useState({});
  const [search, setSearch] = useState("");
  const [debouncedSearch] = useDebounce(search, 300);
  const [vendors, setVendors] = useState([]);
  const [action, setAction] = useState(initialActions);
  const [pagination, setPagination] = useState(initialPagination);
  const { slug } = useParams();

  // Get All Vendors
  const { data, isSuccess, isLoading, isFetching } = useGetAllVendorsQuery({
    page: pagination.page,
    limit: pagination.limit,
    ...action,
  });

  useEffect(() => {
    if (isSuccess && data?.data) {
      setVendors(data.data.vendors);
      setPagination(data.data.pagination);
    }
  }, [data, isSuccess]);

  useEffect(() => {
    if (debouncedSearch) {
      // setPagination((prev) => ({ limit: 12, page: 1 }));
      setAction((prev) => ({ ...prev, search }));
    }
  }, [debouncedSearch]);

  useEffect(() => {
    if (!search.trim()) {
      // setPagination((prev) => ({ limit: 12, page: 1 }));
      setAction((prev) => ({ ...prev, search: "" }));
    }
  }, [search]);

  const handlePageChange = (page) => {
    setPagination((prev) => ({ ...prev, page }));
  };

  const handleLimitChange = (limit) => {
    setPagination((prev) => ({
      ...prev,
      limit,
      page: 1,
    }));
  };

  const handleResetFilters = () => {
    setSearch("");
    setAction(initialActions);
    setPagination(initialPagination);
  };

  const handleClose = () => {
    setSelectedVendor(null);
    setShow(false);
  };

  const handleBsuingSubscriptionModel = (item) => {
    setSelectedVendor(item);
    setShow(true);
  };

  return (
    <>
      <div className="d-flex justify-content-between align-items-center flex-wrap w-100 mb-2">
        <div className="total">
          {t("total")} {t("vendors")}: {pagination?.total}
        </div>

        <div className="d-flex flex-wrap gap-2 ms-auto">
          <div className="d-flex flex-grow-1">
            <input
              type="text"
              className="form-control custom-field-one"
              placeholder={`${t("search")}..`}
              value={search}
              onChange={(e) => setSearch(e.target.value.trim())}
            />
          </div>

          <div className="d-flex gap-2 flex-grow-1">
            <button
              className="btn btn-primary addDriver flex-grow-1"
              onClick={handleResetFilters}
            >
              {t("btns.reset")}
            </button>
          </div>
        </div>
      </div>

      <div>
        <ul className="d-flex flex-wrap p-0 vendorsList">
          {isLoading || isFetching ? (
            <div
              style={{
                width: "90vw",
                height: "65vh",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
              }}
              className="text-center"
            >
              <div className="spinner-border" role="status">
                <span className="sr-only p-0"></span>
              </div>
            </div>
          ) : vendors.length > 0 ? (
            vendors.map((item, i) => (
              <li key={i}>
                <div className="inner ps-4 pe-4">
                  <div className="logo d-flex align-items-center justify-content-between">
                    <img
                      src={
                        item.profile_image
                          ? `${server}${item.profile_image}`
                          : "/./images/bus.avif"
                      }
                      className="m-auto"
                      alt=""
                    />
                  </div>
                  <div className="det pt-3 pb-3">
                    <div className="name">{`${item?.full_name || "N/A"}`}</div>
                    <div
                      className="name pt-2"
                      style={{
                        fontSize: "18px",
                      }}
                    >{`${item?.company_name || "N/A"}`}</div>
                    <div className="mt-3 d-flex align-items-center info">
                      <IoLocationOutline className="icon me-3" />
                      {(item && item?.street) || "N/A"}
                    </div>
                    <div className="mt-3 d-flex align-items-center info">
                      <FiPhoneCall className="icon me-3" />
                      {item?.phone || "N/A"}
                    </div>
                    <div className="mt-3 d-flex align-items-center info ">
                      <IoMailOutline className="icon me-3" />
                      <span className="wordBreak">{item?.email || "N/A"}</span>
                    </div>
                    <div className="mt-3">
                      {slug === "bus-charter-reservations" ? (
                        <NavLink className="bookBtn" to={`book/${item.id}`}>
                          {t("book")} {t("now")}
                        </NavLink>
                      ) : (
                        <NavLink
                          className="bookBtn"
                          to=""
                          onClick={() => handleBsuingSubscriptionModel(item)}
                        >
                          {t("book")} {t("now")}
                        </NavLink>
                      )}
                    </div>
                  </div>
                </div>
              </li>
            ))
          ) : (
            <div className="text-center m-auto mt-5">
              <span className="text-muted">{`${t("no")} ${t("vendors")} ${t(
                "found",
              )}`}</span>
            </div>
          )}
        </ul>
      </div>

      {/* Pagination */}
      <AdminPagination
        totalPages={pagination.totalPages}
        currentPage={pagination.page}
        limit={pagination.limit}
        onPageChange={handlePageChange}
        onLimitChange={handleLimitChange}
      />

      {show && (
        <Modal
          show={show}
          onHide={handleClose}
          size="lg"
          centered
          backdrop="static"
        >
          <Modal.Header closeButton className="border-0">
            <Modal.Title className="h5">{t("reservations")}</Modal.Title>
          </Modal.Header>
          <BusingSubscriptions user={selectedVendor} onClose={handleClose} />
        </Modal>
      )}
    </>
  );
};
export default Vendors;
